import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCategoryHeirarchy } from '../../redux/getCategoryHeirarchy';
import AddProductForm from '../../component/productsComps/AddProductForm';
import InformationHeader from '../../component/reusable/informationHeader/InformationHeader';
import { exportManufacturerThunk } from '../../redux/manufacturer/getAllManufacturerSlice';
import { getAttributesAddProdThunk, getProductDetails } from '../../redux/productSlice';
import { useParams } from 'react-router-dom';

const EditProduct = () => {
  const { productDetails } = useSelector(state => state.products);
  const [detailsLoading, setDetailsLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState(null);

  const dispatch = useDispatch();
  const { id } = useParams();

  useEffect(() => {
    let isMounted = true;
    setErrorMsg(null);

    const isCurrent = productDetails && String(productDetails?._id || productDetails?.id) === String(id);
    if (!isCurrent) {
      setDetailsLoading(true);
    } else {
      setDetailsLoading(false);
    }

    dispatch(getCategoryHeirarchy());
    dispatch(exportManufacturerThunk());
    dispatch(getAttributesAddProdThunk());

    dispatch(getProductDetails(id))
      .then((res) => {
        if (!isMounted) return;
        setDetailsLoading(false);
        if (res.error || !res.payload) {
          setErrorMsg(res.error?.message || "Product not found or failed to load.");
        }
      })
      .catch((err) => {
        if (!isMounted) return;
        setDetailsLoading(false);
        setErrorMsg(err?.message || "Failed to load product details.");
      });

    return () => {
      isMounted = false;
    };
  }, [id, dispatch]);

  const isProductReady = productDetails && String(productDetails?._id || productDetails?.id) === String(id);

  return (
    <div>
      <InformationHeader
        mainpage="Dashboard"
        prevpage="Product"
        pagename="Edit Product"
        buttonText="Save"
      />
      {detailsLoading && !isProductReady ? (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '300px', fontSize: '16px', color: '#777980' }}>
          Loading product details...
        </div>
      ) : errorMsg && !isProductReady ? (
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', minHeight: '300px', fontSize: '16px', color: '#e71717', gap: '12px' }}>
          <span>{errorMsg}</span>
          <button
            type="button"
            onClick={() => {
              setDetailsLoading(true);
              setErrorMsg(null);
              dispatch(getProductDetails(id));
            }}
            style={{ padding: '8px 16px', borderRadius: '8px', border: '1px solid #512DA8', backgroundColor: '#512DA8', color: '#fff', cursor: 'pointer' }}
          >
            Retry
          </button>
        </div>
      ) : (
        <AddProductForm key={productDetails?._id || id} productDetails={productDetails} from={'edit'} id={id} loadings={detailsLoading} />
      )}
    </div>
  );

};

export default EditProduct;

